module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Data.stock),
      expression: "Data.stock"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.Data.stock)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Data, "stock", $event.target.value)
      }
    }
  })])])]), _c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Data.max_stock),
      expression: "Data.max_stock"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.Data.max_stock)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Data, "max_stock", $event.target.value)
      }
    }
  })])])]), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Data.expired_date),
      expression: "Data.expired_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.Data.expired_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Data, "expired_date", $event.target.value)
      }
    }
  })])])]), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Data.patch_number),
      expression: "Data.patch_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.Data.patch_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Data, "patch_number", $event.target.value)
      }
    }
  })])])]), _c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "action-button-group"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.update
    }
  }, [_vm._v("更新")]), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.del
    }
  }, [_vm._v("刪除")]), _c('Confirm', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.confirm),
      expression: "confirm"
    }],
    attrs: {
      "message": '確定刪除?'
    },
    on: {
      "response": _vm.confirmDel
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("庫存")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("最大庫存")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("有效期限")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("批號")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d49041b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/ADCManagement/DrugDetail.vue
// module id = 1381
// module chunks = 1